import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_CONFIG = {
  shop_name: "Delivery Ricambi",
  phone: "+39 377 593 3993",
  phone_href: "tel:+393775933993",
  whatsapp: "https://wa.me/393775933993",
  pos_link: "",
  bonifico_enabled: false,
  iban: { intestatario: "Delivery Ricambi", iban: "", banca: "", bic: "" },
};

const ShopContext = createContext(null);

export const ShopProvider = ({ children }) => {
  const [config, setConfig] = useState(FALLBACK_CONFIG);
  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("dr_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    axios
      .get(`${API}/config`)
      .then((r) => setConfig({ ...FALLBACK_CONFIG, ...r.data }))
      .catch(() => {});
  }, []);

  useEffect(() => {
    localStorage.setItem("dr_cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) =>
    setCart((prev) => {
      const ex = prev.find((i) => i.id === product.id);
      if (ex) return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + 1 } : i));
      return [
        ...prev,
        { id: product.id, name: product.name, code: product.code, price: product.price, image: product.image, qty: 1 },
      ];
    });

  const setQty = (id, qty) =>
    setCart((prev) => (qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))));

  const clearCart = () => setCart([]);

  const total = cart.reduce((s, i) => s + i.price * i.qty, 0);
  const count = cart.reduce((s, i) => s + i.qty, 0);

  return (
    <ShopContext.Provider value={{ config, cart, addToCart, setQty, clearCart, total, count }}>
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => useContext(ShopContext);
